import { FeedInPowerDto } from '../api/dto'
import { FeedInPowerModel } from '../model'

const fromFeedInPowerModelToDtoTransformer = (model: FeedInPowerModel): FeedInPowerDto => ({
  installedPeakPower: model.installedPvPower,
  connectedPower: model.connectedPower,
  derateAtPercentValue: model.powerReduction,
  derateAtConnectedPower: !model.powerReductionRelatedTo,
  maxFusePower: model.backupCurrent,
})

export default fromFeedInPowerModelToDtoTransformer
